import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactPopup from '../components/ContactPopup';
import HeroSection from '../sections/HeroSection';
import AboutSection from '../sections/AboutSection';
import ServicesSection from '../sections/ServicesSection';
import WhyChooseUsSection from '../sections/WhyChooseUsSection';
import ProcessSection from '../sections/ProcessSection';
import PricingSection from '../sections/PricingSection';
import IndustriesSection from '../sections/IndustriesSection';
import BenefitsSection from '../sections/BenefitsSection';
import TrustSection from '../sections/TrustSection';
import FAQSection from '../sections/FAQSection';
import CTASection from '../sections/CTASection';
import ContactSection from '../sections/ContactSection';

const HomePage = () => {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);
  const location = useLocation();

  const handleContactClick = () => {
    setIsContactPopupOpen(true);
  };

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Set meta title and description
    document.title = 'Professional Trademark Registration Services | USPTO Filing Experts';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert trademark registration services in the United States. File your USPTO trademark application with 98% success rate. Comprehensive search, fast filing, and affordable pricing. Protect your brand today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Expert trademark registration services in the United States. File your USPTO trademark application with 98% success rate. Comprehensive search, fast filing, and affordable pricing. Protect your brand today.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, federal trademark, trademark application');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, federal trademark, trademark application';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    
    // Handle hash navigation (scroll to section if hash exists in URL)
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Navbar onContactClick={handleContactClick} />
      
      <main>
        <HeroSection onContactClick={handleContactClick} />
        <AboutSection />
        <ServicesSection />
        <WhyChooseUsSection />
        <ProcessSection />
        <PricingSection onContactClick={handleContactClick} />
        <IndustriesSection />
        <BenefitsSection />
        <TrustSection />
        <FAQSection />
        <CTASection onContactClick={handleContactClick} />
        <ContactSection onContactClick={handleContactClick} />
      </main>

      <Footer />
      
      <ContactPopup 
        open={isContactPopupOpen} 
        onOpenChange={setIsContactPopupOpen} 
      />
    </div>
  );
};

export default HomePage;
